// src/features/task/detail/ParentLink.tsx
// Link to a task's parent. Entity references carry no title; the typed
// resolver fetches each accessible parent once through its owning service.

import { Link } from 'react-router-dom';
import { observer } from '@react';
import { useI18n } from '@react/hooks';
import { useParentTitles } from '@/features/task/useParentTitles';

interface ParentLinkProps {
  parent: {
    id?: string;
    type_name?: string;
    type_id?: string;
    title?: string;
    display_name?: string;
  };
}

export const ParentLink = observer(({ parent }: ParentLinkProps) => {
  const { t } = useI18n();
  const id = parent.id || '';
  const titles = useParentTitles([parent]);

  const label = parent.title
    || parent.display_name
    || titles[id]
    || t('references.unavailableParent');

  const isProject = parent.type_name === 'project' || parent.type_id === 'project';
  const isTeam = parent.type_name === 'team' || parent.type_id === 'team';
  const isDocument = parent.type_name === 'document' || parent.type_id === 'document';
  const to = isProject
    ? `/projects/${id}`
    : isTeam
      ? `/teams/${id}`
      : isDocument
        ? `/documents/${id}`
        : `/tasks/${id}`;

  return (
    <Link to={to} className="truncate text-primary hover:underline">
      {label}
    </Link>
  );
});

export default ParentLink;
